import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dialogModal : {isOpen: false, activeObject:null},
  eventModal : {isOpen: false, activeObject:null},
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    /* Modal */
    openModal: (state, action) => {
      state.dialogModal = {isOpen : true, activeObject : action.payload};
    },
    closeModal: (state, action) => {
      state.dialogModal = {isOpen : false, activeObject :null, isReadOnly : null};
    },

    /* Event Modal */
    openModalEvent: (state, action) => {
      state.eventModal = {isOpen : true, activeObject : action.payload.event_data_guid, isReadOnly : action.payload.read_only};
      //body element overflow: hidden;
      document.body.style.overflow = "hidden";
    },
    closeModalEvent: (state, action) => {
      state.eventModal = {isOpen : false, activeObject :null, isReadOnly : null};
      //body element overflow: auto;
      document.body.style.overflow = "auto";
    },
  },
});

export const {  openModal, closeModal, 
                openModalEvent, closeModalEvent} = modalSlice.actions;

export default modalSlice.reducer;
